import { render, staticRenderFns } from "./NotFoundRecords.vue?vue&type=template&id=bc690eb2&scoped=true"
import script from "./NotFoundRecords.vue?vue&type=script&lang=js"
export * from "./NotFoundRecords.vue?vue&type=script&lang=js"
import style0 from "./NotFoundRecords.vue?vue&type=style&index=0&id=bc690eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc690eb2",
  null
  
)

export default component.exports